<template>
  <span className="search_value_wrapper">
    <span className="search-label">{{ selected.label + " : " }}</span>
    {{ renderType(selected) }}
    <span className="value_close" @mousedown="onCancelClick"><i className="fa fa-close"></i></span>
  </span>
</template>

<script>
export default {
  name: "SearchComponent",
  props: ["selected"],
  data() {
    return {};
  },
  methods: {
    renderType(selected) {
      var type = selected.type;
      var defaultProps = {
        onUpdateFilter: this.selected
      };
      switch (type) {
        case "text":
          return <b-input />;
      }
    },
    onCancelClick() {}
  }
};
</script>

<style lang="sass">
</style>